import { Component, OnDestroy } from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { Router } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-account-preference',
  templateUrl: './account-preference.component.html',
  styleUrls: ['./account-preference.component.scss']
})
export class AccountPreferenceComponent implements OnDestroy {
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private emitterService: EmitterService,
    private router: Router

  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode=>{
      this.langCode = langCode;
    });
  }
  close(){
    this.router.navigate([this.langCode+'/myaccount'])
    this.emitterService.broadcastAccountPreferenceHeaderSource(true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
